<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <div class="d-flex justify-start">
          <router-link to="/polls">
            <v-icon color="#00AAD3"> mdi-arrow-left-thin </v-icon>
            <span class="color-primary mt-1">Back </span>
          </router-link>
        </div>
      </v-col>

      <!-- <v-col cols="12" md="6">
        <div class="d-flex justify-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">
                <v-icon class="pr-2">mdi-tune </v-icon>
                Setting
                <v-icon style="font-size: x-large; color: #595459">
                  mdi-menu-down</v-icon
                >
              </v-btn>
            </template>
            <v-list>
              <v-card flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-share-variant</v-icon>
                    <span class="ml-4 text_style">Share</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <router-link to="">
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                    >
                      <v-icon color="#646464">mdi-poll</v-icon>
                      <span class="ml-4 text_style">Report</span>
                    </v-btn>
                  </router-link>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-account-supervisor</v-icon>
                    <span class="ml-4 text_style">List of completed</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style">Edit</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-delete</v-icon>
                    <span class="ml-4 text_style">Delete</span>
                  </v-btn>
                </v-list>
              </v-card>
            </v-list>
          </v-menu>
          <div></div>
        </div>
      </v-col> -->
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12" md="6">
            <v-card rounded="lg" flat>
              <v-img width="300px" height="119px" :src="image"></v-img>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <div>
              <div>
                <span class="font-16">{{ ID }} </span>
              </div>
              <div>
                <span class="font-24">{{ name }} </span>
              </div>
              <div class="mt-4">
                <span class="stlye-text-color">
                  Completed by {{ completed }} Users
                </span>
              </div>
              <div>
                <span class="stlye-text-color"
                  >Start Date: {{ lastupadte }}
                </span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div>
      <v-card color="#F6F8FC" flat class="mt-7 pb-9">
        <v-tabs v-model="tab" background-color="white" color="#49B45F">
          <v-tab v-for="item in itemss" :key="item">
            <span class="tabs_text"> {{ item }}</span>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" color="#49B45F">
          <v-tab-item>
            <v-card color="#F6F8FC" flat>
              <div class="px-9 pt-4">
                <div>
                  <span class="mt-5 font-24">Reports</span>
                </div>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-card
                      class="my-5"
                      max-height="420"
                      max-width="400"
                      outlined
                      style="border-radius: 10px"
                    >
                      <div>
                        <div class="report_h1 px-5 pt-4">
                          <b>Q1: </b>Which do you like? <br />(Check all that
                          apply)
                        </div>

                        <div class="px-6 pb-10">
                          <div class="mt-7" v-for="(item, i) in items" :key="i">
                            <div class="d-flex justify-space-between">
                              <span class="font-span-text py-1">{{
                                item.text
                              }}</span>
                              <span class="font-span-text py-1"
                                >{{ item.icon }}
                              </span>
                            </div>
                            <div>
                              <v-progress-linear
                                :color="item.color"
                                style="
                                  background: rgba(115, 136, 169, 0.353283);
                                  border-radius: 10px;
                                "
                                :value="item.value"
                                height="13"
                              >
                              </v-progress-linear>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card
                      class="my-5"
                      max-height="400"
                      max-width="400"
                      outlined
                      style="border-radius: 10px"
                    >
                      <div>
                        <div class="report_h1 px-5 pr-15 pt-4">
                          <b>Q2: </b>Which one of these is<br />
                          your favorite?
                        </div>
                        <div class="d-flex justify-center py-14">
                          <Doughnut
                            :chart-options="chartOptions"
                            :chart-data="chartData"
                            :chart-id="chartId"
                            :dataset-id-key="datasetIdKey"
                            :plugins="plugins"
                            :css-classes="cssClasses"
                            :styles="styles"
                            :width="width"
                            :height="height"
                          />
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card
                      class="my-5"
                      max-height="400"
                      max-width="400"
                      outlined
                      style="border-radius: 10px"
                    >
                      <div>
                        <div class="report_h1 px-5 pr-15 pt-4">
                          <b>Q3: </b>On a scale of 1 to 5, how <br />would you
                          rate it?
                        </div>
                        <div class="d-flex justify-center py-14">
                          <Bar
                            :chart-options="barchartOptions"
                            :chart-data="barchartData"
                            :chart-id="chartId1"
                            :dataset-id-key="datasetIdKey"
                            :plugins="plugins"
                            :css-classes="cssClasses"
                            :styles="styles"
                            :width="width"
                            :height="height"
                            :style="myStyles"
                          />
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-card
                      class="my-5"
                      max-height="420"
                      max-width="400"
                      outlined
                      style="border-radius: 10px"
                    >
                      <div>
                        <div class="report_h1 px-5 pt-4">
                          <b>Q1: </b>Which do you like? <br />(Check all that
                          apply)
                        </div>

                        <div class="px-6 pb-10">
                          <div class="mt-7" v-for="(item, i) in items" :key="i">
                            <div class="d-flex justify-space-between">
                              <span class="font-span-text py-1">{{
                                item.text
                              }}</span>
                              <span class="font-span-text py-1"
                                >{{ item.icon }}
                              </span>
                            </div>
                            <div>
                              <v-progress-linear
                                :color="item.color"
                                style="
                                  background: rgba(115, 136, 169, 0.353283);
                                  border-radius: 10px;
                                "
                                :value="item.value"
                                height="13"
                              >
                              </v-progress-linear>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card
                      class="my-5"
                      max-height="400"
                      max-width="400"
                      outlined
                      style="border-radius: 10px"
                    >
                      <div>
                        <div class="report_h1 px-5 pr-15 pt-4">
                          <b>Q2: </b>Which one of these is<br />
                          your favorite?
                        </div>
                        <div class="d-flex justify-center py-14">
                          <Doughnut
                            :chart-options="chartOptions"
                            :chart-data="chartData"
                            :chart-id="chartId"
                            :dataset-id-key="datasetIdKey"
                            :plugins="plugins"
                            :css-classes="cssClasses"
                            :styles="styles"
                            :width="width"
                            :height="height"
                          />
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card
                      class="my-5"
                      max-height="400"
                      max-width="400"
                      outlined
                      style="border-radius: 10px"
                    >
                      <div>
                        <div class="report_h1 px-5 pr-15 pt-4">
                          <b>Q3: </b>On a scale of 1 to 5, how <br />would you
                          rate it?
                        </div>
                        <div class="d-flex justify-center py-14">
                          <Bar
                            :chart-options="barchartOptions"
                            :chart-data="barchartData"
                            :chart-id="chartId1"
                            :dataset-id-key="datasetIdKey"
                            :plugins="plugins"
                            :css-classes="cssClasses"
                            :styles="styles"
                            :width="width"
                            :height="height"
                            :style="myStyles"
                          />
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card color="#F6F8FC" flat>
              <div>
                <v-row class="pt-5 mb-3 px-9 pb-0">
                  <span class="mt-5 font-24">User List (53)</span>
                  <v-col cols="12" md="6" class="mt-5">
                    <v-text-field
                      dense
                      prepend-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      solo
                      hide-details
                      flat
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </div>
              <v-card class="mx-9" outlined>
                <v-data-table
                  hide-default-footer
                  :headers="headers"
                  :items="desserts"
                  :items-per-page="5"
                ></v-data-table>
              </v-card>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
  </div>
</template>

<script>
import { Doughnut } from "vue-chartjs/legacy";
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  scales,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  scales
);

export default {
  name: "DoughnutChart",
  components: {
    Doughnut,
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "doughnut-chart",
    },
    chartId1: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 220,
    },
    height: {
      type: Number,
      default: 220,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    items: [
      { text: "Option 1", icon: "70/100", value: "70", color: "#147AD6" },
      { text: "Option 2", icon: "30/100", value: "30", color: "#EC6666" },
      { text: "Option 3", icon: "80/100", value: "80", color: "#79D2DE" },
    ],

    chartData: {
      datasets: [
        {
          backgroundColor: ["#157AD6", "#7AD2DE", "#EC6665"],
          data: [54, 26, 20],
          borderWidth: 0,
        },
      ],
      labels: ["Option 1", "Option 2", "Option 3"],
    },
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.label,
                currentValue = context.raw,
                total = context.chart._metasets[context.datasetIndex].total;

              var percentage = parseFloat(
                ((currentValue / total) * 100).toFixed(1)
              );

              return label + ": " + +(+percentage) + "%";
            },
          },
        },
        legend: {
          position: "bottom",
          labels: {
            usePointStyle: true,
            boxWidth: 10,
            padding: 25,
          },
        },
      },
    },
    barchartData: {
      datasets: [
        {
          backgroundColor: ["#157AD6"],
          data: [27, 63, 46, 64, 43],
          borderWidth: 0,
          width: "1px",
          borderRadius: Number.MAX_VALUE,
          borderSkipped: false,
        },
      ],
      labels: ["1", "2", "3", "4", "5"],
    },
    barchartOptions: {
      scales: {
        display: false,
        x: {
          grid: {
            display: false,
            borderColor: "White",
          },
          title: {
            display: false,
            text: "Time in Seconds",
            color: "red",
            font: {
              size: 24,
              weight: "bold",
            },
          },
        },
        y: {
          grid: {
            display: false,
            borderColor: "White",
          },
          title: {
            display: false,
            text: "Speed in Miles per Hour",
            color: "green",
            font: {
              size: 18,
              weight: "bold",
            },
          },
        },
      },

      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
    },

    interval: {},
    value: 0,
    tab: null,
    image: "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
    ID: "#1",
    name: "[Name_or_title_survey]",
    completed: "53",
    lastupadte: "11/12/2021",
    itemss: ["Report", "User List"],
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    headers: [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "index",
      },
      { text: "Name", value: "name" },
      { text: "Email", value: "email" },
      { text: "Date taken", value: "dateat" },
      { text: "", value: "action" },
    ],
    desserts: [
      {
        index: "1",
        name: "[Name_user]",
        email: "axel@agencycoda.com",
        dateat: "11/12/2021",
      },
      {
        index: "2",
        name: "[Name_user]",
        email: "axel@agencycoda.com",
        dateat: "11/12/2021",
      },
      {
        index: "3",
        name: "[Name_user]",
        email: "-",
        dateat: "11/12/2021",
      },
      {
        index: "4",
        name: "[Name_user]",
        email: "-",
        dateat: "11/12/2021",
      },
      {
        index: "5",
        name: "[Name_user]",
        email: "axel@agencycoda.com",
        dateat: "11/12/2021",
      },
      {
        index: "6",
        name: "[Name_user]",
        email: "axel@agencycoda.com",
        dateat: "11/12/2021",
      },
      {
        index: "7",
        name: "[Name_user]",
        email: "axel@agencycoda.com",
        dateat: "11/12/2021",
      },
      {
        index: "8",
        name: "[Name_user]",
        email: "axel@agencycoda.com",
        dateat: "11/12/2021",
      },
      {
        index: "9",
        name: "[Name_user]",
        email: "axel@agencycoda.com",
        dateat: "11/12/2021",
      },
      {
        index: "10",
        name: "[Name_user]",
        email: "axel@agencycoda.com",
        dateat: "11/12/2021",
      },
    ],
  }),
  beforeDestroy() {
    clearInterval(this.interval);
  },
  computed: {
    myStyles() {
      return {
        height: `${220}px`,
        position: "relative",
        LinearScale: false,
      };
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      if (this.value === 100) {
        return (this.value = 0);
      }
      this.value += 10;
    }, 1000);
  },
};
</script>

<style scoped>
.color-primary {
  font-family: "Quicksand";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;

  letter-spacing: 0.25px;

  color: #00aad3;
}
.font-16 {
  font-family: "Quicksand";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;

  color: rgba(34, 34, 34, 0.95);
}
.font-24 {
  font-family: "Quicksand";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;

  color: rgba(34, 34, 34, 0.95);
}
.stlye-text-color {
  font-family: "Quicksand";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;

  color: rgba(34, 34, 34, 0.7);
}
.tabs_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.25px;
  text-transform: none;
}
.report_h1 {
  font-family: "DM Sans";
  font-size: 22px;
  font-weight: 500;
}
.font-span-text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
  color: #7c828a;
}
</style>
